<!-- @format -->

<template>
  <div class="container">
    <div class="about">
      <p class="placeholder"></p>
      <img src="../../assets/image/mobile/banner.png"
           alt="" />
      <div class="content">
        <p class="head">關於澳覓</p>
        <p class="sub">About Aomi</p>
        <p class="section">
          澳門網絡傳媒發展有限公司是澳門一家領先的創新型科技公司，其獨立開發及運營的「澳覓APP」於2016年6月份上線，是澳門首家吃喝玩樂、優惠搜索、並支持雙幣支付（澳門幣和人民幣）的生活電商平臺。
        </p>
        <p class="section">
          澳覓業務範圍較廣，借助移動互聯網信息技術和線下服務能力，開展外賣、團購、房產、休閒娛樂、美容美髮等業務，為消費者提供值得信賴的本地商家推薦、優惠資訊、消費指南、O2O閉環交易等服務。未來我們也會持續不斷為用戶提供更多服務，為人們的美好生活不斷努力。
        </p>
      </div>
    </div>
    <div class="history">
      <p class="head">發展歷史</p>
      <p class="sub">DEVELOPMENT HISTORY</p>
      <div class="ul">
        <span>2020</span>
        <ul>
          <li>
            <i>· </i>
            <p>
              累計用戶突破<span>280萬</span>，日活躍用戶超過<span>8萬</span>，年度交易額破<span>9億</span>
            </p>
          </li>
          <li>
            <i>· </i>
            <p>
              9月 “澳觅超市” 自營線上超市開業，滿足澳門人優質食材、日用品的全品類購物平台，經營類包含蔬果、肉禽蛋類、水產、冷凍急凍食品同百貨類，品質食材平民價。
            </p>
          </li>
        </ul>
      </div>
      <div class="ul">
        <span>2019</span>
        <ul>
          <li>
            <i>· </i>
            <p>
              累計用戶突破<span>100萬</span>，日活躍用戶超過<span>7萬</span>
            </p>
          </li>
          <li>
            <i>· </i>
            <p>
              收錄澳門優質餐飲、零售及美容美髮等行業商家超過<span>5000家</span>，合作餐飲商家超過<span>1600家</span>
            </p>
          </li>
          <li>
            <i>· </i>
            <p>首次聯動澳門老店推出「澳覓聯名春節禮盒」</p>
          </li>
          <li>
            <i>· </i>
            <p>推出澳覓文創產品，並參與「澳門Hush音樂節」，深受用戶喜愛</p>
          </li>
        </ul>
      </div>
      <div class="ul">
        <span>2018</span>
        <ul>
          <li>
            <i>· </i>
            <p>累計用戶突破50萬以及年度交易額破<span>3.8億</span></p>
          </li>
          <li>
            <i>· </i>代理國內第一收銀系統品牌一屏芯科技，加速餐飲信息化升級
          </li>
          <li>
            <i>· </i>將點評黑珍珠餐廳海外頒獎禮落地澳門，助力澳門美食之都發展
          </li>
          <li><i>· </i>澳覓品牌重磅升級，推出澳覓大家庭形象</li>
          <li><i>· </i>首次聯動澳門遊艇展舉辦「澳覓·甜蜜新風尚」</li>
        </ul>
      </div>
      <div class="ul">
        <span>2017</span>
        <ul>
          <li>
            <i>· </i>
            <p>4月登上澳門APPLE STORE總排行榜及熱搜榜<span>第1名</span></p>
          </li>
          <li><i>· </i>11月工銀澳覓聯名信用卡正式推出</li>
        </ul>
      </div>
      <div class="ul">
        <span>2016</span>
        <ul>
          <li><i>· </i>6月1日澳覓APP正式上線</li>
          <li><i>· </i>11月外賣及團購業務正式啟動</li>
        </ul>
      </div>
      <div class="ul">
        <span>2015</span>
        <ul>
          <li><i>· </i>澳覓成為美團和大眾點評在澳門的唯一官方合作夥伴</li>
        </ul>
      </div>
    </div>
    <div class="concat">
      <img src="../../assets/image/mobile/concat.jpg"
           alt="" />
    </div>
    <Footer />
  </div>
</template>
<script>
import Footer from '../../components/mobile/Footer'
export default {
  components: {
    Footer
  }
}
</script>
<style lang="scss" scoped>
.container {
  background-color: #292936;
  .about {
    background-color: #fff;
    border-bottom-left-radius: 18px;
    border-bottom-right-radius: 18px;
    .placeholder {
      width: 100%;
      height: 60px;
      background-color: #20202c;
    }
    img {
      width: 335px;
      margin: -60px auto 0;
    }
    .content {
      padding: 0 20px 25px;
      font-size: 14px;
      color: #2d2f3c;
      text-align: left;
      margin-top: 25px;
      .head {
        font-size: 18px;
        font-weight: bold;
      }
      .sub {
        font-size: 12px;
        color: #ff3159;
        font-weight: bold;
      }
      .section {
        line-height: 1.8;
        margin-top: 15px;
        &:last-child {
          margin-top: 25px;
        }
      }
    }
  }
  .history {
    padding: 0 20px 25px;
    margin-top: 34px;
    text-align: left;
    .head {
      font-size: 18px;
      font-weight: bold;
      color: #fff;
    }
    .sub {
      font-size: 12px;
      color: #ff3159;
      font-weight: bold;
    }
    .ul {
      display: flex;
      color: #fff;
      > span {
        position: relative;
        font-size: 24px;
        font-weight: bold;
        padding-left: 0;
        z-index: 1;
        &::after {
          position: absolute;
          left: 0;
          top: 22px;
          content: '';
          width: 100%;
          height: 5px;
          background: linear-gradient(to bottom right, #fd3159, #7f2a42);
          z-index: -1;
        }
      }
      &:not(:first-child) {
        margin-top: 20px;
      }
    }
    ul {
      margin-left: 12px;
      li {
        display: flex;
        line-height: 1.8;
        font-size: 14px;
        font-weight: bold;
        text-align: left;
        i {
          padding-right: 5px;
        }
        span {
          color: #ff3159;
        }
        &:not(:last-child) {
          margin-bottom: 12px;
        }
        &:first-child {
          padding-top: 5px;
        }
      }
    }
  }
  .concat {
    width: 100%;
    img {
      width: 100%;
    }
  }
}
</style>
